import React from 'react';

import { Divider } from '@ag1/ui';

import styles from './styles.module.scss';

const FooterDivider = () => <Divider className={styles.divider} />;

export default FooterDivider;
